module.exports = __webpack_public_path__ + "fonts/Gilroy-Light.f9b62dd8.woff";